import Axios from "axios";

import { 
  SET_MY_LEAVE_LIST, 
  UNSET_MY_LEAVE_LIST,
  SET_LEAVE_DAY_COUNT,
  UNSET_LEAVE_DAY_COUNT
} from "@/store/mutation-types";

import {
  leaveApplicationList as leaveApplicationListApi,
  saveUpdateLeaveApplication as saveUpdateLeaveApplicationApi,
  leaveDayCount as leaveDayCountApi,
  latestLeaveApplication,
  employeeLeaveBalanceById
} from "@/store/api";

const state = {
  getMyLeaveList: [],
  editingLeaveApplication: null,
  getLeaveDayCount:null,
  viewingLeaveApplication: null,
};

const getters = {
  getMyLeaveList(state) {
    return state.getMyLeaveList;
  },
  editingLeaveApplication: (state) => state.editingLeaveApplication,
  viewingLeaveApplication: (state) => state.viewingLeaveApplication,
  getLeaveDayCount(state) {
    return state.getLeaveDayCount;
  },
};

// Mutations
const mutations = {
  [SET_MY_LEAVE_LIST](state, data) {
    state.getMyLeaveList = data;
  },
  [UNSET_MY_LEAVE_LIST](state) {
    state.getMyLeaveList = [];
  },
  [SET_LEAVE_DAY_COUNT](state, data) {
    state.getLeaveDayCount = data;
  },
  [UNSET_LEAVE_DAY_COUNT](state) {
    state.getLeaveDayCount = null;
  },
  editingLeaveApplication(state, leaveApplication) {
    state.editingLeaveApplication = leaveApplication;
  },
  viewingLeaveApplication(state, leaveApplication) {
    state.viewingLeaveApplication = leaveApplication;
  },
};


// Actions
const actions = {
    saveUpdateLeaveApplication({ commit }, data) {
        commit("SET_LOADING", {color: "primary"});
        return new Promise((resolve, reject) => {
        Axios.post(saveUpdateLeaveApplicationApi, data)
            .then(function (response) {
                resolve(response);
            })
            .catch(function (error) {
            reject(error);
            })
            .then((always) => {
                commit("UNSET_LOADING");
            });
        });
    },

  getMyLeaveList({ commit }, data) {
    commit("SET_LOADING", { color: "primary" });

    return new Promise((resolve, reject) => {
      Axios.get(`${leaveApplicationListApi}`, { params: data })
        .then((response) => {
          commit(SET_MY_LEAVE_LIST, response.data.data || []);
          resolve(response);
        })
        .catch((error) => {
          commit(UNSET_MY_LEAVE_LIST);
          reject(error);
        })
        .finally(() => {
          commit("UNSET_LOADING");
        });
    });
  },

  getLatestLeaveApplicationById({ commit }, id) {
    commit("SET_LOADING", { color: "primary" });
    const latestLeaveApplicationApi = latestLeaveApplication.replace('{id}', id)
    return new Promise((resolve, reject) => {
      Axios.get(latestLeaveApplicationApi)
        .then((response) => {
          resolve(response.data.data);
        })
        .catch((error) => {
          reject(error);
        })
        .finally(() => {
          commit("UNSET_LOADING");
        });
    });
  },

  getEmployeeLeaveBalancesById({ commit }, id) {
    commit("SET_LOADING", { color: "primary" });
    const employeeLeaveBalance = employeeLeaveBalanceById.replace('{id}', id)
    return new Promise((resolve, reject) => {
      Axios.get(employeeLeaveBalance)
        .then((response) => {
          resolve(response.data.data);
        })
        .catch((error) => {
          reject(error);
        })
        .finally(() => {
          commit("UNSET_LOADING");
        });
    });
  },


  getLeaveDayCount({ commit }, data) {
    commit("SET_LOADING", { color: "primary" });

    return new Promise((resolve, reject) => {
      Axios.post(leaveDayCountApi,data)
        .then((response) => {
          commit(SET_LEAVE_DAY_COUNT, response.data.data || []);
          resolve(response);
        })
        .catch((error) => {
          commit(UNSET_LEAVE_DAY_COUNT);
          reject(error);
        })
        .finally(() => {
          commit("UNSET_LOADING");
        });
    });
  },

  getLeaveApplicationById({ commit }, id) {
    commit("SET_LOADING", { color: "primary" });

    return new Promise((resolve, reject) => {
      Axios.get(`${leaveApplicationListApi}/${id}`)
        .then((response) => {
          commit("viewingLeaveApplication", response.data.data || null);
          resolve(response.data.data);
        })
        .catch((error) => {
          commit("viewingLeaveApplication", null);
          reject(error);
        })
        .finally(() => {
          commit("UNSET_LOADING");
        });
    });
  },

};


export default {
  state,
  getters,
  actions,
  mutations,
};